<script setup>
defineProps({
  size: {
    type: Number,
    default: 24
  },
  fill: {
    type: String,
    default: 'currentColor'
  },
  d: String
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    :height="size"
    :width="size"
  >
    <path fill-rule="evenodd" clip-rule="evenodd" :d="d" :fill="fill" />
  </svg>
</template>
